/*
 * Visual do brinde do app BOGOS na página de produto (snippets/product-gift-offer.liquid).
 * O app monta o bloco .fg-gift-thumbnail-offer e cuida do carrinho; aqui só entram a etiqueta
 * "Brinde", o nome e o valor riscado de cada brinde e a validade da oferta. Os dados vêm da própria
 * configuração do app (window.FGSECOMAPP.offers) e o preço é conferido no produto original.
 */
(() => {
  const strings = window.acqualiveGiftOffer || {};
  const productRequests = new Map();
  const giftIcon =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';

  // A loja vende só em reais; o formatMoney do tema depende de window.themeVariables, que não existe aqui
  const formatMoney = (cents) => (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  const offerData = (id) => (window.FGSECOMAPP?.offers || []).find((offer) => String(offer.id) === String(id));

  const fetchProduct = (handle) => {
    if (!productRequests.has(handle)) {
      const root = window.Shopify?.routes?.root || '/';
      productRequests.set(
        handle,
        fetch(`${root}products/${encodeURIComponent(handle)}.js`)
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      );
    }
    return productRequests.get(handle);
  };

  const element = (tag, className, html) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (html !== undefined) node.innerHTML = html;
    return node;
  };

  const escapeHtml = (text) => {
    const node = document.createElement('span');
    node.textContent = text ?? '';
    return node.innerHTML;
  };

  function giftLine(gift) {
    const variant = gift.variants?.[0];
    const line = element('li', 'acq-gift__item');
    const render = (title, cents) => {
      const price = cents > 0 ? `<s>${formatMoney(cents)}</s> ` : '';
      line.innerHTML = `${escapeHtml(title)}: ${price}<span class="acq-gift__free">${escapeHtml(strings.free || 'grátis')}</span>`;
    };

    render(gift.title, Math.round(Number(variant?.original_price || 0) * 100));

    if (gift.original_product_handle) {
      fetchProduct(gift.original_product_handle).then((product) => {
        if (!product) return;
        const original = product.variants.find((item) => String(item.id) === String(variant?.original_variant_shopify_id));
        render(product.title, (original || product.variants[0]).price);
      });
    }

    return line;
  }

  function untilText(endTime) {
    if (!endTime || !strings.until) return '';
    const end = new Date(endTime);
    if (Number.isNaN(end.getTime())) return '';
    const date = end.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', timeZone: 'America/Sao_Paulo' });
    return strings.until.replace('__DATE__', date);
  }

  function enhance(offer) {
    offer.classList.add('acq-gift');

    const data = offerData(offer.dataset.fgOfferId);
    const gifts = data?.gift_products || [];
    offer.classList.toggle('acq-gift--multi', gifts.length > 1);

    const info = element('div', 'acq-gift__info');
    info.appendChild(element('span', 'acq-gift__badge', `${giftIcon}${escapeHtml(strings.badge || 'Brinde')}`));

    if (gifts.length) {
      const list = element('ul', 'acq-gift__items');
      gifts.forEach((gift) => list.appendChild(giftLine(gift)));
      info.appendChild(list);
    }

    const until = untilText(data?.end_time);
    if (until) info.appendChild(element('p', 'acq-gift__until', escapeHtml(until)));

    // O título do app entra por último, logo abaixo da etiqueta: se algo acima falhar, ele continua no lugar
    const header = offer.querySelector('.fg-gift-thumbnail-offer-header');
    if (header) info.insertBefore(header, info.children[1] || null);

    offer.prepend(info);
  }

  let scheduled = false;
  const scan = () => {
    scheduled = false;
    // Pela falta do texto, não da classe: o BOGOS remonta o conteúdo do bloco e mantém o elemento
    document.querySelectorAll('.fg-gift-thumbnail-offer').forEach((offer) => {
      if (!offer.querySelector(':scope > .acq-gift__info')) enhance(offer);
    });
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    setTimeout(scan, 50); // setTimeout, não requestAnimationFrame: este para em aba oculta
  };

  // O BOGOS monta (e remonta, ao trocar de variante) o bloco depois do carregamento
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
